window.getCookie = function(cname) {
  var name = cname + "=";
  var decodedCookie;
  try {
    decodedCookie = decodeURIComponent(document.cookie);
  } catch (e) {
    window.console.log({ decodeError: e });
    return "";
  }
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

window.setCookie = function(cname, cvalue, exhour) {
  var d = new Date();
  d.setTime(d.getTime() + exhour * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
};

window.removeCookie = function(cname) {
  var d = new Date();
  d.setTime(d.getTime() - 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();

  document.cookie = cname + "=_;" + expires + ";path=/";
};
